module.exports = __webpack_public_path__ + "static/adb-4b6c48098801397169e3047a3867d4b7.svg";